// src/components/SectionTitle.tsx

import React from "react";
import { Typography, Box } from "@mui/material";

interface SectionTitleProps {
  title: string;
}

const SectionTitle: React.FC<SectionTitleProps> = ({ title }) => {
  return (
    <Box
      sx={{
        borderBottom: "1px solid #ddd", // Thin gray line under the title
        pb: 1,                           // Padding at bottom so text doesn't sit right on the line
        mb: 2,                           // Margin below if needed
        paddingTop: 2,
        paddingLeft: 3,
        paddingRight: 3,
        paddingBottom: 2
      }}
    >
      <Typography
        sx={{
          fontSize: "20px",
          fontWeight: 600,
          margin: 0,
        }}
      >
        {title}
      </Typography>
    </Box>
  );
};

export default SectionTitle;
